// NOTE: NSAI-4570 — every number the app formats prints Western digits, in every
// language. NSAI-5022 chose them over Arabic-Indic ones for the chat timestamp,
// and a grid that formats one tile through the device locale and the next one
// raw shows `٤` beside `4` under an Arabic device.
export const LATIN_NUMBERING_SYSTEM = "latn";

// NOTE: U+0660–U+0669 (Arabic-Indic) and U+06F0–U+06F9 (Extended Arabic-Indic,
// what a Persian or Urdu device prints).
export const EASTERN_DIGIT_PATTERN = /[٠-٩۰-۹]/g;

export const ARABIC_INDIC_ZERO_CODE = 0x0660;

export const EXTENDED_ARABIC_INDIC_ZERO_CODE = 0x06f0;

// NOTE: An engine that prints Eastern digits prints the Arabic separators with
// them — `١٬٢٣٤٫٥` — so they are mapped back together, or the result would read
// `1٬234٫5`.
export const ARABIC_THOUSANDS_SEPARATOR_PATTERN = /٬/g;

export const ARABIC_DECIMAL_SEPARATOR_PATTERN = /٫/g;
